// extracted by mini-css-extract-plugin
module.exports = {"csat_table":"CSATStyle_csat_table__Qu1Id","ratedComment_Section":"CSATStyle_ratedComment_Section__2nHJ6","text-align-left":"CSATStyle_text-align-left__qgQ2R"};